module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9qsBQ"))).then(() => module.bundle.root('jnagv'));